import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { StorageService } from 'src/app/services/storage.service';
import { JsaStats } from '../models/jsa-stats.model';
import { JsaStatsService } from 'src/app/services/jsa-stats.service';
import { JsaStatsActions } from '../actions/jsa-stats.actions';

export class JsaStatsStateModel {
    is_refreshing: boolean
    jsa_stats: JsaStats[]
}

@State<JsaStatsStateModel>({
    name: 'jsa_stats',
    defaults: {
        is_refreshing: true,
        jsa_stats: []
    }
})
@Injectable()
export class JsaStatsState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private jsa_statsService: JsaStatsService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<JsaStatsStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {                      
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {             
        if (this.storageService.is_initialized) {
            const state_model: JsaStatsStateModel = change.currentValue      
            this.storageService.set('jsa_stats', JSON.stringify(state_model))    
        }  
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('jsa_stats');        
        if (json) {
            const state_model: JsaStatsStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new JsaStatsActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new JsaStatsActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.jsa_statsService.getStats()    
        if (objs != null) {
          const many = JsaStats.buildMany(objs)                  
          this.store.dispatch(new JsaStatsActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: JsaStatsStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: JsaStatsStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: JsaStatsStateModel) {
        return state.jsa_stats
    }

    @Action(JsaStatsActions.Refresh)
    async refresh({patchState}: StateContext<JsaStatsStateModel>, {  }:JsaStatsActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(JsaStatsActions.Init)
    init({setState, getState}: StateContext<JsaStatsStateModel>, { payload }:JsaStatsActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new JsaStatsActions.Refresh())
    }
    
    @Action(JsaStatsActions.Set)
    set({setState}: StateContext<JsaStatsStateModel>, { payload }:JsaStatsActions.Set) {             
        setState({   
            is_refreshing: false,         
            jsa_stats: payload
        })
    }
}
